module.exports = __webpack_public_path__ + "static/media/arrow-right-grey.7348260a.svg";